import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import AccurityIcon from '../../../icon/components/AccurityIcon';
import { AlignStyles } from '../../constants/textStyleConstants';
import { useEditorContext } from '../../logic/EditorContext';
var AlignControls = function () {
    var _a = useEditorContext(), contentHelper = _a[1];
    var handleToggleAlignment = function (event, alignmentType) {
        event.preventDefault();
        if (contentHelper.blockTypeAtSelection === 'unstyled' || Object.values(AlignStyles).includes(contentHelper.blockTypeAtSelection)) {
            contentHelper.toggleBlockType(alignmentType);
        }
        else {
            contentHelper.toggleInlineStyle(alignmentType);
        }
    };
    var handleToggleAlignLeft = function (event) {
        handleToggleAlignment(event, AlignStyles.alignLeft);
    };
    var handleToggleAlignCenter = function (event) {
        handleToggleAlignment(event, AlignStyles.alignCenter);
    };
    var handleToggleAlignRight = function (event) {
        handleToggleAlignment(event, AlignStyles.alignRight);
    };
    var handleToggleAlignJustify = function (event) {
        handleToggleAlignment(event, AlignStyles.alignJustify);
    };
    var isIconSelected = function (alignment) {
        return contentHelper.blockTypeAtSelection === alignment ? 'inherit' :
            contentHelper.inlineStyleAtSelection.has(alignment) ? 'inherit' : 'disabled';
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { title: "Align left" },
            React.createElement(AccurityIcon, { iconName: "mui:FormatAlignLeft", className: "RichEditor-singleControl", color: isIconSelected(AlignStyles.alignLeft), onMouseDown: handleToggleAlignLeft, fontSize: "small" })),
        React.createElement(Tooltip, { title: "Align center" },
            React.createElement(AccurityIcon, { iconName: "mui:FormatAlignCenter", className: "RichEditor-singleControl", color: isIconSelected(AlignStyles.alignCenter), onMouseDown: handleToggleAlignCenter, fontSize: "small" })),
        React.createElement(Tooltip, { title: "Align right" },
            React.createElement(AccurityIcon, { iconName: "mui:FormatAlignRight", className: "RichEditor-singleControl", color: isIconSelected(AlignStyles.alignRight), onMouseDown: handleToggleAlignRight, fontSize: "small" })),
        React.createElement(Tooltip, { title: "Justify" },
            React.createElement(AccurityIcon, { iconName: "mui:FormatAlignJustify", className: "RichEditor-singleControl", color: isIconSelected(AlignStyles.alignJustify), onMouseDown: handleToggleAlignJustify, fontSize: "small" }))));
};
export default AlignControls;
//# sourceMappingURL=AlignControls.js.map